module.exports = __webpack_public_path__ + "img/logo-1.2e2124f0.png";